import * as React from 'react';
import SheetModal from 'ted-ui/build/SheetModal';
import { IProductSheetProps } from '@applications/order-tracker/config/order-tracker-new-common/types';
import Tabs, { TabPanel } from 'ted-ui/build/Tabs';
import {
  ProductSheetTabIndexes,
  ProductSheetTabLabels,
  ProductSheetTabRoutes,
} from '@applications/order-tracker/config/order-tracker-new-common/constants';
import ProductDetailsTab from './components/product-details-tab';
import ProgressTrackerTab from './components/progress-tracker-tab';
import { getProductSheetRoutePath } from '@applications/order-tracker/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProductNameAndTab } from './utils';

const iconDevelopmentURL = require('../../../../images/able-sprites.svg');

const ProductSheet = ({ open, product, parentPageRoute, goBackEvent, relativeRoute }: IProductSheetProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { productNumber , currentTab } = getProductNameAndTab(pathname);
  const switchTab = (selectedTab: string) =>
    navigate(`${!relativeRoute ? parentPageRoute + '/' : ''}${getProductSheetRoutePath(productNumber, selectedTab)}`);

  const handleTabChange = (tabIndex: number) => {
    switchTab(
      ProductSheetTabRoutes[Object.keys(ProductSheetTabRoutes)[tabIndex]]
    );
  };

  return (
    <SheetModal
      open={open}
      size={'medium'}
      className="product-details-sheet-dialog"
      title={product?.productName || ''}
      onClose={goBackEvent}
      developmentUrl={iconDevelopmentURL}
    >
      <Tabs
        activeTabIndex={ProductSheetTabIndexes[currentTab]}
        developmentUrl={iconDevelopmentURL}
        id="product-sheet-tabs"
        listDescription="Order product sheet tabs"
        onChange={handleTabChange}
      >
        <TabPanel
          activeTabIndex={ProductSheetTabIndexes[currentTab]}
          index={ProductSheetTabIndexes[ProductSheetTabRoutes.ProductDetails]}
          label={ProductSheetTabLabels.ProductDetails}
          panelId={`product-sheet-${ProductSheetTabRoutes.ProductDetails}`}
          tabId={`product-sheet-${ProductSheetTabRoutes.ProductDetails}`}
        >
          <ProductDetailsTab product={product} />
        </TabPanel>
        <TabPanel
          activeTabIndex={ProductSheetTabIndexes[currentTab]}
          index={ProductSheetTabIndexes[ProductSheetTabRoutes.ProgressTracker]}
          label={ProductSheetTabLabels.ProgressTracker}
          panelId={`product-sheet-${ProductSheetTabRoutes.ProgressTracker}`}
          tabId={`product-sheet-${ProductSheetTabRoutes.ProgressTracker}`}
        >
          <ProgressTrackerTab product={product} />
        </TabPanel>
      </Tabs>
    </SheetModal>
  );
};

export default ProductSheet;
